// extracted by mini-css-extract-plugin
export default {"skillSet":"SkillSection_skillSet__iqA9B","sectionTitle":"SkillSection_sectionTitle__6j7UL","skillContainer":"SkillSection_skillContainer__Dl7q2"};